<div
    [cdkTrapFocus]="true"
    [cdkTrapFocusAutoCapture]="true"
    [attr.role]="'dialog'"
    [attr.aria-labelledby]="prefixTab + '-image-gallery'"
    class="zoom-modal-container"
    [ngClass]="{
        'zoom-mobile': isMobile,
        'zoom-desktop': !isMobile,
    }"
    (scroll)="stopPropagation($event)">
    <h2
        [attr.id]="prefixTab + '-image-gallery'"
        i18n="@@hermes.accessibility.product-images-gallery-title"
        hSrOnlyNoSnippet>
        Image gallery
    </h2>
    @if(assets) {
    <h-product-image-zoom-image
        [product]="product"
        [asset]="assets[currentIndex]"
        [imageIndex]="currentIndex"
        [backgroundWhite]="backgroundWhite"
        [style.width]="containerWithForInitialSCale"
        [style.overflow]="'hidden'"></h-product-image-zoom-image>
    } @if (!isMobile) {
    <h-image-zoom-scale-slider></h-image-zoom-scale-slider>
    }
    <div class="gallery-images-zoom">
        @if (!isMobile) {
        <h-images-gallery
            [product]="product"
            [backgroundWhite]="backgroundWhite"
            [prefixTab]="'tab-zoom'"
            [currentIndex]="currentIndex"
            [context]="'zoom'"
            (indexChange)="handleIndexChange($event)"></h-images-gallery>
        } @else {
        <!-- This condition should be removed after the activation new zoom pdp on mobile. -->
        <h-product-image-zoom-gallery
            [currentIndex]="currentIndex"
            [prefixTab]="'zoom-tab'"
            [assets]="assets"
            [product]="product"
            [infiniteLoop]="true"
            [orientation]="'horizontal'"
            (indexChange)="handleIndexChange($event)"></h-product-image-zoom-gallery>
        }
    </div>

    <div class="close" (click)="closeModal($event)">
        @if (!isMobile) {
        <h-icon-button
            cdkFocusInitial
            id="close-button-image-gallery"
            name="close-button"
            [labelledBy]="'zoom-close-button'"
            [describedBy]="prefixTab + '-image-gallery'"
            i18n-label
            [changeOpacityOnHover]="true"
            [border]="false"
            lineHeight="0"
            (click)="closeModal($event)">
            <h-svg-icon name="cross" class="close-icon"></h-svg-icon>
        </h-icon-button>
        <span id="zoom-close-button" i18n="@@hermes.accessibility.close_tray" hSrOnlyNoSnippet> Close </span>
        } @else {
        <!-- This condition should be removed after the activation new zoom pdp on mobile. -->
        <button cdkFocusInitial [attr.aria-describedby]="prefixTab + '-image-gallery'" class="close-button">
            <span i18n="@@hermes.accessibility.close_tray" hSrOnlyNoSnippet> Close </span>
            <svg class="close-svg" xmlns="http://www.w3.org/2000/svg" id="close" viewBox="0 0 24 24">
                <svg:path
                    id="close_background"
                    fill="transparent"
                    d="M0 0h24v24H0z"
                    [attr.data-name]="'close background'" />
                <svg:path
                    id="Line"
                    d="M0 0l28.484 1.055"
                    class="stroke"
                    [attr.transform]="'rotate(45 -.72796526 3.55846692)'" />
                <svg:path
                    id="Line_Copy"
                    d="M0 1.055L28.484 0"
                    class="stroke"
                    [attr.data-name]="'Line Copy'"
                    [attr.transform]="'rotate(-45 26.96909583 8.96903474)'" />
            </svg>
        </button>
        }
    </div>
</div>
